import { NgStyle } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { SafeHtmlPipe } from '@app/finxone-web-frontend/app/lib/pipes/SafeHtml.pipe';
import { AccountService } from '@app/finxone-web-frontend/app/lib/services/account-service/account-service.service';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CardState } from '@app/finxone-web-frontend/app/lib/state/card.state';
import { isAndroid } from '@app/finxone-web-frontend/app/lib/utils/device-detection.utils';
import { getWalletTokenList } from '@app/finxone-web-frontend/app/lib/utils/flutter.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  BaseCssProperties,
  ProviderClass,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Subject, interval, takeUntil, combineLatest, filter, take } from 'rxjs';
import { PageConfigurationProvider } from '../../../zones/page-configuration.provider';

@Component({
  selector: 'finxone-web-frontend-add-to-google-pay-widget',
  templateUrl: './add-to-google-pay-widget.component.html',
  imports: [NgStyle, SafeHtmlPipe],
})
export class AddToGooglePayWidgetComponent implements OnInit, OnDestroy {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();

  public buttonColorType = '#000000';
  public marginStyle: baseCssConfigStyle;
  private flutterWebView = (window as any).flutter_inappwebview;
  private currentCardId: string;
  private currentCardMaskedPan: string;
  public showAddToGpay = false;
  public originalSvg = `<svg width="92" height="18" viewBox="0 0 92 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_26321_5643)">
<path d="M5.24545 4.26562H7.10366L10.9488 14.5001H9.16198L8.23288 11.87H4.11623L3.18713 14.5001H1.40039L5.24545 4.26562ZM7.68971 10.3978L6.61767 7.38169L6.21744 6.18101H6.13167L5.73144 7.38169L4.6594 10.3978H7.68971ZM17.3772 13.5996H17.2915C17.1009 13.9045 16.8102 14.1713 16.4195 14.4C16.0288 14.6192 15.5619 14.7288 15.0187 14.7288C14.5708 14.7288 14.142 14.6383 13.7323 14.4572C13.332 14.2666 12.9795 14.0046 12.6745 13.6711C12.3696 13.3375 12.1266 12.9468 11.9455 12.499C11.7645 12.0415 11.674 11.5413 11.674 10.9981C11.674 10.4549 11.7645 9.95935 11.9455 9.51148C12.1266 9.05407 12.3696 8.65862 12.6745 8.32509C12.9795 7.99157 13.332 7.73428 13.7323 7.55322C14.142 7.36264 14.5708 7.26733 15.0187 7.26733C15.5619 7.26733 16.0288 7.3817 16.4195 7.61039C16.8102 7.82957 17.1009 8.09162 17.2915 8.39655H17.3772L17.2915 7.42457V4.26562H18.8781V14.5001H17.3772V13.5996ZM15.3189 13.2565C15.5857 13.2565 15.843 13.2041 16.0908 13.0993C16.3481 12.9945 16.5672 12.8468 16.7483 12.6562C16.9389 12.4656 17.0913 12.2321 17.2057 11.9558C17.32 11.6699 17.3772 11.3507 17.3772 10.9981C17.3772 10.6455 17.32 10.331 17.2057 10.0547C17.0913 9.76877 16.9389 9.53054 16.7483 9.33995C16.5672 9.14937 16.3481 9.00166 16.0908 8.89684C15.843 8.79202 15.5857 8.73961 15.3189 8.73961C15.0425 8.73961 14.7805 8.79202 14.5327 8.89684C14.285 9.00166 14.0658 9.15413 13.8752 9.35424C13.6942 9.54483 13.5465 9.7783 13.4321 10.0547C13.3177 10.331 13.2606 10.6455 13.2606 10.9981C13.2606 11.3507 13.3177 11.6651 13.4321 11.9415C13.5465 12.2178 13.6942 12.4561 13.8752 12.6562C14.0658 12.8468 14.285 12.9945 14.5327 13.0993C14.7805 13.2041 15.0425 13.2565 15.3189 13.2565ZM26.068 13.5996H25.9823C25.7917 13.9045 25.501 14.1713 25.1103 14.4C24.7196 14.6192 24.2527 14.7288 23.7095 14.7288C23.2617 14.7288 22.8328 14.6383 22.4231 14.4572C22.0228 14.2666 21.6703 14.0046 21.3653 13.6711C21.0604 13.3375 20.8174 12.9468 20.6363 12.499C20.4553 12.0415 20.3648 11.5413 20.3648 10.9981C20.3648 10.4549 20.4553 9.95935 20.6363 9.51148C20.8174 9.05407 21.0604 8.65862 21.3653 8.32509C21.6703 7.99157 22.0228 7.73428 22.4231 7.55322C22.8328 7.36264 23.2617 7.26733 23.7095 7.26733C24.2527 7.26733 24.7196 7.3817 25.1103 7.61039C25.501 7.82957 25.7917 8.09162 25.9823 8.39655H26.068L25.9823 7.42457V4.26562H27.5689V14.5001H26.068V13.5996ZM24.0097 13.2565C24.2765 13.2565 24.5338 13.2041 24.7816 13.0993C25.0389 12.9945 25.258 12.8468 25.4391 12.6562C25.6297 12.4656 25.7821 12.2321 25.8965 11.9558C26.0108 11.6699 26.068 11.3507 26.068 10.9981C26.068 10.6455 26.0108 10.331 25.8965 10.0547C25.7821 9.76877 25.6297 9.53054 25.4391 9.33995C25.258 9.14937 25.0389 9.00166 24.7816 8.89684C24.5338 8.79202 24.2765 8.73961 24.0097 8.73961C23.7334 8.73961 23.4713 8.79202 23.2235 8.89684C22.9758 9.00166 22.7566 9.15413 22.566 9.35424C22.385 9.54483 22.2373 9.7783 22.1229 10.0547C22.0086 10.331 21.9514 10.6455 21.9514 10.9981C21.9514 11.3507 22.0086 11.6651 22.1229 11.9415C22.2373 12.2178 22.385 12.4561 22.566 12.6562C22.7566 12.8468 22.9758 12.9945 23.2235 13.0993C23.4713 13.2041 23.7334 13.2565 24.0097 13.2565ZM33.7956 8.89684H32.5663V7.49604H33.7956V5.35195H35.3822V7.49604H37.1117V8.89684H35.3822V12.013C35.3822 12.1845 35.4012 12.3417 35.4394 12.4847C35.4775 12.6276 35.5346 12.7467 35.6109 12.842C35.7729 13.0231 35.9778 13.1136 36.2255 13.1136C36.378 13.1136 36.4971 13.1041 36.5829 13.085C36.6686 13.0564 36.7592 13.0183 36.8544 12.9707L37.3404 14.3715C37.1403 14.4477 36.9307 14.5049 36.7115 14.543C36.4923 14.5906 36.2446 14.6145 35.9682 14.6145C35.6347 14.6145 35.3393 14.562 35.082 14.4572C34.8247 14.3524 34.6008 14.2095 34.4102 14.0284C34.0004 13.6186 33.7956 13.0612 33.7956 12.356V8.89684ZM41.9723 7.26733C42.506 7.26733 42.9967 7.36264 43.4446 7.55322C43.8925 7.73428 44.2784 7.99157 44.6024 8.32509C44.9264 8.65862 45.1789 9.05407 45.36 9.51148C45.541 9.96888 45.6316 10.4645 45.6316 10.9981C45.6316 11.5317 45.541 12.0273 45.36 12.4847C45.1789 12.9421 44.9264 13.3375 44.6024 13.6711C44.2784 14.0046 43.8925 14.2666 43.4446 14.4572C42.9967 14.6383 42.506 14.7288 41.9723 14.7288C41.4387 14.7288 40.9479 14.6383 40.5001 14.4572C40.0522 14.2666 39.6662 14.0046 39.3423 13.6711C39.0183 13.3375 38.7657 12.9421 38.5847 12.4847C38.4036 12.0273 38.3131 11.5317 38.3131 10.9981C38.3131 10.4645 38.4036 9.96888 38.5847 9.51148C38.7657 9.05407 39.0183 8.65862 39.3423 8.32509C39.6662 7.99157 40.0522 7.73428 40.5001 7.55322C40.9479 7.36264 41.4387 7.26733 41.9723 7.26733ZM41.9723 13.2565C42.2392 13.2565 42.4964 13.2041 42.7442 13.0993C42.992 12.9945 43.2111 12.8468 43.4017 12.6562C43.6018 12.4656 43.7591 12.2321 43.8734 11.9558C43.9878 11.6699 44.0449 11.3507 44.0449 10.9981C44.0449 10.6455 43.9878 10.331 43.8734 10.0547C43.7591 9.76877 43.6018 9.53054 43.4017 9.33995C43.2111 9.14937 42.992 9.00166 42.7442 8.89684C42.4964 8.79202 42.2392 8.73961 41.9723 8.73961C41.7055 8.73961 41.4482 8.79202 41.2005 8.89684C40.9527 9.00166 40.7288 9.14937 40.5286 9.33995C40.3381 9.53054 40.1856 9.76877 40.0712 10.0547C39.9569 10.331 39.8997 10.6455 39.8997 10.9981C39.8997 11.3507 39.9569 11.6699 40.0712 11.9558C40.1856 12.2321 40.3381 12.4656 40.5286 12.6562C40.7288 12.8468 40.9527 12.9945 41.2005 13.0993C41.4482 13.2041 41.7055 13.2565 41.9723 13.2565Z" fill="currentColor"/>
<path d="M70.5806 9.22872V13.7122H69.1577V2.64062H72.9297C73.8857 2.64062 74.7009 2.9593 75.3679 3.59661C76.0496 4.23393 76.3905 5.01205 76.3905 5.93098C76.3905 6.87213 76.0496 7.65025 75.3679 8.28016C74.7083 8.91007 73.8931 9.22131 72.9297 9.22131H70.5806V9.22872ZM70.5806 4.00419V7.86516H72.9594C73.5226 7.86516 73.9969 7.67248 74.3674 7.29453C74.7454 6.91659 74.938 6.45712 74.938 5.93838C74.938 5.42704 74.7454 4.975 74.3674 4.59706C73.9969 4.20429 73.53 4.01161 72.9594 4.01161H70.5806V4.00419Z" fill="currentColor"/>
<path d="M80.1103 5.88672C81.1627 5.88672 81.9927 6.16832 82.6003 6.73154C83.208 7.29475 83.5118 8.06546 83.5118 9.04367V13.7124H82.1557V12.6601H82.0964C81.511 13.5271 80.7254 13.9569 79.7472 13.9569C78.9098 13.9569 78.2132 13.7124 77.65 13.2159C77.0868 12.7194 76.8052 12.1043 76.8052 11.3632C76.8052 10.5777 77.1016 9.95518 77.6945 9.49572C78.2873 9.02884 79.0803 8.79911 80.0659 8.79911C80.9107 8.79911 81.6073 8.95474 82.1483 9.26599V8.93992C82.1483 8.4434 81.9556 8.0284 81.5628 7.6801C81.1701 7.3318 80.7106 7.16135 80.1844 7.16135C79.3915 7.16135 78.7616 7.49483 78.3021 8.16921L77.0497 7.38367C77.7389 6.38323 78.7616 5.88672 80.1103 5.88672ZM78.2725 11.3854C78.2725 11.756 78.4281 12.0672 78.7468 12.3118C79.058 12.5563 79.4286 12.6823 79.851 12.6823C80.4512 12.6823 80.9848 12.46 81.4517 12.0153C81.9185 11.5707 82.1557 11.052 82.1557 10.4517C81.711 10.1034 81.096 9.92554 80.303 9.92554C79.725 9.92554 79.2433 10.0663 78.8579 10.3405C78.4652 10.6296 78.2725 10.9779 78.2725 11.3854Z" fill="currentColor"/>
<path d="M91.249 6.13281L86.5062 17.0414H85.0389L86.8026 13.2249L83.6753 6.13281H85.2241L87.477 11.5723H87.5066L89.7002 6.13281H91.249Z" fill="currentColor"/>
<path d="M64.9225 8.32295C64.9225 7.85904 64.881 7.41514 64.804 6.98828H58.8398V9.43381L62.2747 9.43455C62.1354 10.2483 61.687 10.9419 61.0001 11.4044V12.991H63.0447C64.2385 11.8861 64.9225 10.2527 64.9225 8.32295Z" fill="#4285F4"/>
<path d="M60.9996 11.4065C60.4305 11.7904 59.6975 12.0149 58.8401 12.0149C57.1838 12.0149 55.7788 10.8989 55.2756 9.39453H53.1665V11.0308C54.2114 13.1043 56.359 14.5272 58.8401 14.5272C60.5549 14.5272 61.9956 13.9632 63.0442 12.9924L60.9996 11.4065Z" fill="#34A853"/>
<path d="M55.0778 8.18292C55.0778 7.76051 55.1482 7.35218 55.2764 6.96831V5.33203H53.1673C52.7353 6.18944 52.4922 7.15728 52.4922 8.18292C52.4922 9.20855 52.736 10.1764 53.1673 11.0339L55.2764 9.39753C55.1482 9.01365 55.0778 8.60532 55.0778 8.18292Z" fill="#FABB05"/>
<path d="M58.8401 4.34425C59.7761 4.34425 60.6142 4.66661 61.276 5.29652L63.0879 3.48609C61.9874 2.4612 60.5527 1.83203 58.8401 1.83203C56.3598 1.83203 54.2114 3.25488 53.1665 5.32839L55.2756 6.96467C55.7788 5.4603 57.1838 4.34425 58.8401 4.34425Z" fill="#E94235"/>
</g>
<defs>
<clipPath id="clip0_26321_5643">
<rect width="91" height="18" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>
`;
  public modifiedSvg: any;

  constructor(
    public pageConfig: PageConfigurationProvider,
    public dataIn: ProviderClass<any>,
    private configService: ConfigService,
    private store: Store,
    private accountService: AccountService,
  ) {}

  ngOnInit() {
    this.buttonColorType = this.dataIn.attri.widgetProperties?.buttonColorType;
    this.marginStyle = this.configService.getSpecificBaseCssStyle(this.dataIn?.attri, [
      BaseCssProperties.MARGIN,
    ]);
    this.resizeSVG();

    this.waitForCardDataAndCheckHideCondition();
    this.listenToUpdateEvents();
  }

  ngOnDestroy() {
    window.removeEventListener('pageshow', this.handlePageShow);
    window.removeEventListener('tokenizationResult', this.handleTokenizationResult);
  }

  private listenToUpdateEvents() {
    window.addEventListener('pageshow', this.handlePageShow);
    window.addEventListener('tokenizationResult', this.handleTokenizationResult);

    if (this.flutterWebView) {
      // poll every 5 seconds to check if the card is added to Google Pay
      // and update the button visibility accordingly
      interval(5000)
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.waitForCardDataAndCheckHideCondition();
          // We should already have currentCardMaskedPan from the previous wait function
          // If not then do not update, the snapshot could potentially cause another race condition
          if (this.currentCardMaskedPan) {
            this.accountService.currentCardIsOnXPay(this.currentCardMaskedPan);
          }
        });
    }
  }

  // Creating references to the event listeners, so we can unsubscribe in ngOnDestroy
  private handlePageShow = () => {
    this.waitForCardDataAndCheckHideCondition();
  };
  private handleTokenizationResult = () => {
    this.waitForCardDataAndCheckHideCondition();
  };

  private resizeSVG() {
    const width = this.dataIn.attri.css_config?.textWidth ?? 92;
    const height = this.dataIn.attri.css_config?.textHeight ?? 18;
    this.modifiedSvg = this.originalSvg
      .replace(/width="(\d+)"/, `width="${width}"`)
      .replace(/height="(\d+)"/, `height="${height}"`);
  }

  private waitForCardDataAndCheckHideCondition() {
    // Combine both card observables and wait for them to have valid data
    combineLatest([
      this.store.select(CardState.getCurrentCardId),
      this.store.select(CardState.getCurrentCardDetail),
    ])
      .pipe(
        // Filter out null and empty string values to ensure we have valid data
        filter(([cardId, cardDetail]) => {
          return !!(
            cardId?.length &&
            cardDetail &&
            Object.keys(cardDetail).length &&
            cardDetail?.maskedPan?.length
          );
        }),
        take(1),
        takeUntil(this.destroy$),
      )
      .subscribe(([cardId, cardDetail]) => {
        this.currentCardId = cardId;
        this.currentCardMaskedPan = cardDetail.maskedPan;

        this.checkHideConditionGpayButton().catch((error) => {
          console.error('Error in checkHideConditionGpayButton:', error);
          // Set a safe default state
          this.showAddToGpay = false;
        });
      });
  }

  private async checkHideConditionGpayButton() {
    // Additional safety checks
    if (!this.currentCardId || !this.currentCardMaskedPan) {
      console.warn('Card data not available, hiding Google Wallet button');
      this.showAddToGpay = false;
      return;
    }
    const deviceType = this.configService.getDeviceData().deviceType;
    const isWorkflow = this.configService.getActiveConfigType().isWorkflow;

    if (!isWorkflow) {
      //Check the device type
      if (deviceType !== 'mobile') {
        return;
      }
      // Only show the button for Android devices
      if (!isAndroid()) {
        this.showAddToGpay = false;
        return;
      }
    } else {
      // is Workflow
      this.showAddToGpay = true;
      return;
    }

    let parsedTokenList: any[] = [];
    const { tokenList: tokenListFromDeviceStorage } = await getWalletTokenList();
    if (tokenListFromDeviceStorage.length > 0) {
      parsedTokenList = tokenListFromDeviceStorage;
      localStorage.setItem('tokenList', JSON.stringify(parsedTokenList));
    }

    /* Check in the token list if any fpanLastFour matches the last four digits of the current card ID.
      If a match is found, the 'Add to Google Pay' button should not be displayed,
      indicating that the card is already added to the Google Pay wallet.
    */
    this.showAddToGpay = !parsedTokenList.some(
      (token) => token.fpanLastFour === this.currentCardMaskedPan?.slice(-4),
    );
  }

  public onClickAddToGpay() {
    if (this.flutterWebView) {
      this.flutterWebView.callHandler('addCardHandler', this.currentCardId);
    }
  }

  get buttonStyle() {
    return {
      'background-color': `${this.dataIn.attri.widgetProperties?.buttonColorType ?? '#000000'}`,
      'border-radius': `${this.dataIn.attri.css_config?.borderRadius ?? 0}px`,
      width: `${this.dataIn.attri.css_config?.width ?? 0}px`,
      height: `${this.dataIn.attri.css_config?.height ?? 0}px`,
      color: this.buttonColorType === '#000000' ? '#FFFFFF' : '#000000',
      ...this.marginStyle,
    };
  }
}
